import { getEnvelopeError, unwrapEntity, wrapRequest } from "./afterschoolHelpers"
import { API_URL_CUSTOMER } from "./urls"

const firstText = (...values) => {
  for (const value of values) {
    if (value != null) {
      const text = String(value).trim()

      if (text) {
        return text
      }
    }
  }

  return ""
}

const mapCustomerProfile = (entity) => ({
  customerId: entity?.customerId ?? null,
  login: firstText(entity?.login),
  email: firstText(entity?.email),
  phone: firstText(entity?.phone, entity?.phone1, entity?.phoneNumber),
  firstName: firstText(entity?.firstName, entity?.name),
  lastName: firstText(entity?.lastName, entity?.surname),
})

const getCustomerProfile = () =>
  window.axios
    .get(API_URL_CUSTOMER + "v1/get")
    .then(({ data }) => mapCustomerProfile(unwrapEntity(data, "Failed to load account")))
    .catch((error) => {
      throw getEnvelopeError(error)
    })

const updateCustomerProfile = ({
  oldLogin,
  login,
  oldEmail,
  email,
  phone,
  firstName,
  lastName,
  password,
  confirmPassword,
}) => {
  const requestBodyDto = {
    oldLogin: firstText(oldLogin, login),
    login: firstText(login),
    oldEmail: firstText(oldEmail, email),
    email: firstText(email),
    phone: firstText(phone),
    firstName: firstText(firstName),
    lastName: firstText(lastName),
  }

  const nextPassword = firstText(password)

  if (nextPassword) {
    requestBodyDto.password = nextPassword

    if (firstText(confirmPassword)) {
      requestBodyDto.confirmPassword = firstText(confirmPassword)
    }
  }

  return window.axios
    .post(API_URL_CUSTOMER + "v1/createOrUpdate", wrapRequest(requestBodyDto))
    .then(({ data }) => mapCustomerProfile(unwrapEntity(data, "Failed to save account")))
    .catch((error) => {
      throw getEnvelopeError(error)
    })
}

export { getCustomerProfile, updateCustomerProfile }
